import yuva2 from "../../assets/images/profile/yuva2.jpg";
import flower from "../../assets/images/profile/flower.jpg";

import css3 from "../../assets/images/logo/css3.svg";
import js from "../../assets/images/logo/js.svg";
import react from "../../assets/images/logo/reaact.svg";

function About() {
  return (
    <>
      <section className="section about" id="about">
        <div className="container">
          <figure className="about-banner">
            <img
              src={yuva2}
              width="100"
              height="152"
              loading="lazy"
              alt="Yuvaraj`s"
              className="img-cover"
            />

            <img
              src={flower}
              width="auto"
              height="400"
              loading="lazy"
              alt="Yuva's"
              className="abs-img"
            />

            <div className="abs-icon abs-icon-1">
              <ion-icon name="logo-css3">
                <img src={css3} alt="CSS3" />
              </ion-icon>
            </div>

            <div className="abs-icon abs-icon-2">
              <img src={js} alt="JavaScript" />
            </div>

            <div className="abs-icon abs-icon-3">
              <ion-icon name="logo-react">
                <img src={react} alt="ReactJS" />
              </ion-icon>
            </div>
          </figure>

          <div className="about-content">
            <p className="section-subtitle">I'm a Developer</p>

            <h2 className="h2 section-title">
              I Develop Application that Enhance my Skills
            </h2>

            <p className="section-text">
              A self-motivated, self-taught web developer. Quest to work and
              learn in a real professional and vying ambience that enables me to
              cope with the emerging as well as latest technology and scope for
              widening the spectrum of my knowledge.
            </p>

            <p className="section-text">"Be Good, Do Good"</p>

            <a href="#portfolio" className="btn btn-primary blue">
              View Projects
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
export default About;
